import {
  Box,
  Button,
  IconButton,
  AppBar,
  Toolbar,
  Typography,
} from "@mui/material";
import TenantSelector from "../TenantSelector";
import Sidebar from "../Sidebar";
import { ReactNode } from "react";
import { Logout } from "../../Hooks/http-server";
import SettingsIcon from "@mui/icons-material/Settings";
import { useLocation, useNavigate } from "react-router-dom";
import { PageRoutes } from "../../Utils/constant";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const drawerWidth = 240;

const MainContainer = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isDetailPage =
    location.pathname.includes("/game/") ||
    location.pathname.includes("/game-view-detail/") ||
    location.pathname.includes("/nlp-search") ||
    location.pathname.includes("/setting") ||
    location.pathname.includes("/bumper-video/");

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Sidebar />
      <AppBar
        position="fixed"
        sx={{
          width: `100%`,
          backgroundColor: "white",
          color: "text.primary",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar>
          <Box
            sx={{ width: drawerWidth, display: "flex", alignItems: "center" }}
          >
            <Typography variant="h6" noWrap component="div">
              HTP
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            {isDetailPage && (
              <Button
                onClick={() => navigate(-1)}
                variant="contained"
                size="small"
                startIcon={<ArrowBackIcon />}
                sx={{ mr: 2 }}
              >
                Go Back
              </Button>
            )}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <TenantSelector />
            <IconButton onClick={() => navigate(PageRoutes.SettingBumperVideo)}>
              <SettingsIcon />
            </IconButton>
            <Button onClick={Logout} variant="outlined">
              Log out
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          mt: 8,
          overflow: "auto",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default MainContainer;
